import { Expose, Type } from '@nts/std/serialization';
import { ReportInfoDto } from "./report-info.dto";
import { MultiReportInfoDtoInterface, ReportInfoDtoInterface } from '@nts/std/interfaces';

export class MultiReportInfoDto implements MultiReportInfoDtoInterface {

    constructor() {
        this.reportInfoList = [];
    }

    @Expose()
    @Type(() => ReportInfoDto)
    reportInfoList: ReportInfoDtoInterface[];

}
